import { render, staticRenderFns } from "./InterventionHistory.vue?vue&type=template&id=b6927d08&"
import script from "./InterventionHistory.vue?vue&type=script&lang=js&"
export * from "./InterventionHistory.vue?vue&type=script&lang=js&"
import style0 from "./InterventionHistory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports